import React from "react";

export default function Sponsors() {
  return (
    <div className='sponsorBucket container'>
      <h3>JOIN WITH US</h3>
      <div className=''>NGOs/Partners List</div>
    </div>
  );
}
